import { render } from "./UpdateAppeal.vue?vue&type=template&id=768bec6d"
import script from "./UpdateAppeal.vue?vue&type=script&lang=js"
export * from "./UpdateAppeal.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-student-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__